import { C, font } from './ProfileResult'

export default function SurveyChoice({ onChooseUpload, onChooseSurvey, hasSurvey = false, hasData = false }) {
  return (
    <div style={{
      fontFamily: font.body,
      color: C.text,
      maxWidth: 600,
      margin: '0 auto',
      padding: '40px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 32,
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2 style={{
          fontFamily: font.heading, fontWeight: 400, fontSize: 34,
          color: C.text, margin: '0 0 10px',
        }}>
          Как будем создавать профиль?
        </h2>
        <p style={{ fontSize: 14, color: C.textMuted, margin: 0, lineHeight: 1.6 }}>
          Выбери способ сбора данных. Можно использовать оба — они дополнят друг друга.
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, width: '100%' }}>
        {/* Анкетирование */}
        <button
          onClick={onChooseSurvey}
          style={{
            background: hasSurvey ? 'rgba(77,200,138,0.07)' : 'rgba(184,189,212,0.06)',
            border: `1px solid ${hasSurvey ? C.green + '60' : C.borderHi}`,
            borderRadius: 14,
            padding: '24px 28px',
            textAlign: 'left',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            color: C.text,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
            <span style={{ fontFamily: font.heading, fontSize: 22, fontWeight: 400 }}>
              Пройти анкетирование
            </span>
            {hasSurvey && (
              <span style={{
                fontFamily: font.mono, fontSize: 10, color: C.green,
                background: 'rgba(77,200,138,0.12)', border: `1px solid ${C.green}40`,
                borderRadius: 4, padding: '2px 8px',
              }}>
                ✓ пройдена
              </span>
            )}
          </div>
          <p style={{ fontSize: 13, color: C.textMuted, margin: '0 0 16px', lineHeight: 1.55 }}>
            55 вопросов в двух частях. Профиль строится на основе архетипов Юнга-Пирсон.
            Ответы на вопросы используются как доказательная база.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {['~15 минут', '30 вопросов + 25 адаптивных', 'анонимно', 'без загрузки файлов'].map(tag => (
              <span key={tag} style={{
                fontFamily: font.mono, fontSize: 10, color: C.textMuted,
                background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`,
                borderRadius: 4, padding: '3px 8px',
              }}>
                {tag}
              </span>
            ))}
          </div>
        </button>

        {/* Загрузка данных */}
        <button
          onClick={onChooseUpload}
          style={{
            background: hasData ? 'rgba(77,200,138,0.07)' : 'rgba(255,255,255,0.025)',
            border: `1px solid ${hasData ? C.green + '60' : C.border}`,
            borderRadius: 14,
            padding: '24px 28px',
            textAlign: 'left',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            color: C.text,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
            <span style={{ fontFamily: font.heading, fontSize: 22, fontWeight: 400 }}>
              Загрузить личные данные
            </span>
            {hasData && (
              <span style={{
                fontFamily: font.mono, fontSize: 10, color: C.green,
                background: 'rgba(77,200,138,0.12)', border: `1px solid ${C.green}40`,
                borderRadius: 4, padding: '2px 8px',
              }}>
                ✓ данные есть
              </span>
            )}
          </div>
          <p style={{ fontSize: 13, color: C.textMuted, margin: '0 0 16px', lineHeight: 1.55 }}>
            Telegram, дневник, резюме, Threads. Анализ строится на реальных паттернах поведения.
            Самый точный способ.
          </p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {['Telegram HTML', 'Apple Journal', 'Резюме DOCX', 'Threads JSON'].map(tag => (
              <span key={tag} style={{
                fontFamily: font.mono, fontSize: 10, color: C.textMuted,
                background: 'rgba(255,255,255,0.04)', border: `1px solid ${C.border}`,
                borderRadius: 4, padding: '3px 8px',
              }}>
                {tag}
              </span>
            ))}
          </div>
        </button>
      </div>

      {(hasSurvey || hasData) && (
        <p style={{ fontSize: 12, color: C.textMuted, textAlign: 'center', margin: 0 }}>
          Если загружены и данные, и анкета — расхождения между ними попадают в раздел Аномалии
        </p>
      )}
    </div>
  )
}
